/**
 * Cards de produto (home e coleção): clicar numa cor do wallford-color-picker troca o produto
 * exibido no card, sem sair da página (como no site do Brasil). Na Wallford cada cor é um produto
 * separado, ligado pelo metafield custom.color_variants.
 *
 * Os dados de cada cor (url, título, subtítulo, fotos) vêm no data-wf-product do quadradinho.
 * A troca atualiza: fotos da galeria, nome, subtítulo, todos os links do card (card, galeria,
 * nome, "View product") e a cor marcada. O quick add ("Choose") usa o link do card para buscar o
 * produto (quick-add.js → getProductCardLink), então passa a abrir a cor escolhida.
 *
 * Só age em listas com data-wf-card-swap (setting "Ao clicar numa cor: Trocar o produto no card").
 * Eventos delegados no document: funciona com cards renderizados depois (filtros, paginação).
 */

/** @param {Element} swatch */
function readData(swatch) {
  try {
    return JSON.parse(swatch.getAttribute('data-wf-product') || '');
  } catch {
    return null;
  }
}

/**
 * @param {Element} card
 * @param {{ url: string, title: string, subtitle: string, images: { src: string, srcset: string }[] }} from
 * @param {{ url: string, title: string, subtitle: string, images: { src: string, srcset: string }[] }} to
 */
function swapCard(card, from, to) {
  const fromPath = new URL(from.url, location.origin).pathname;

  // Links do card que apontam para o produto atual (card, galeria, nome, "View product").
  for (const link of card.querySelectorAll('a[href]')) {
    if (link.closest('.wf-color-picker')) continue;
    const url = new URL(link.href, location.origin);
    if (url.pathname === fromPath) link.setAttribute('href', to.url);
  }

  // Fotos: cada slide recebe uma foto do novo produto (o hover alterna entre o 1º e o 2º slide).
  if (to.images.length) {
    card.querySelectorAll('.card-gallery slideshow-slide img, .card-gallery img').forEach((img, index) => {
      const image = to.images[index % to.images.length];
      img.setAttribute('srcset', image.srcset);
      img.setAttribute('src', image.src);
      img.setAttribute('alt', to.title);
    });
  }

  // Nome do produto: o elemento de texto cujo conteúdo é o nome atual.
  for (const el of card.querySelectorAll('p, h2, h3, h4, span')) {
    if (el.closest('.wf-color-picker, quick-add-component, .visually-hidden')) continue;
    if (el.children.length === 0 && el.textContent.trim() === from.title) el.textContent = to.title;
  }
  const hidden = card.querySelector('.product-card__link .visually-hidden');
  if (hidden) hidden.textContent = to.title;

  // Subtítulo (metafield custom.subtitle).
  const subtitle = card.querySelector('.wallford-plp-card__subtitle');
  if (subtitle) {
    subtitle.textContent = to.subtitle;
    subtitle.hidden = !to.subtitle;
  }

  // Quick add: abre o modal pelo link do card; força o botão "Choose" (o "Add" direto usa o formulário do produto original).
  const quickAdd = card.querySelector('quick-add-component');
  if (quickAdd) {
    quickAdd.setAttribute('data-product-title', to.title);
    quickAdd.setAttribute('data-quick-add-button', 'choose');
  }

  // Volta a galeria para a primeira foto.
  const slideshow = card.querySelector('.card-gallery slideshow-component');
  if (slideshow && typeof slideshow.select === 'function') {
    try {
      slideshow.select(0, undefined, { animate: false });
    } catch {}
  }
}

document.addEventListener('click', (event) => {
  const swatch = event.target instanceof Element ? event.target.closest('[data-wf-card-swap] .wf-color-picker__swatch') : null;
  if (!swatch) return;

  const card = swatch.closest('product-card');
  const list = swatch.closest('[data-wf-card-swap]');
  if (!card || !list) return; // fora de um card: segue o link normalmente

  event.preventDefault();
  if (swatch.classList.contains('is-selected')) return;

  const current = list.querySelector('.wf-color-picker__swatch.is-selected');
  const from = current ? readData(current) : null;
  const to = readData(swatch);
  if (!from || !to) {
    location.href = swatch.getAttribute('href'); // sem dados: comportamento de link
    return;
  }

  swapCard(card, from, to);

  for (const item of list.querySelectorAll('.wf-color-picker__swatch')) {
    const selected = item === swatch;
    item.classList.toggle('is-selected', selected);
    if (selected) item.setAttribute('aria-current', 'true');
    else item.removeAttribute('aria-current');
  }
});
